/*
 * wh-journey-layout-fix.js
 * WorkoutHealthy — master plan pre-publish gate item 1. Added 2026-08-11.
 *
 * PROBLEM
 * Journey (Mediavine) resolves its in-content target to `.blog-layout` and injects
 * `div.mv-ad-box` as a direct child of it — a sibling of `.blog-layout__main` and
 * `.blog-layout__sidebar`. The theme rule
 *   .blog-layout > div:not(.blog-layout__main):not(.blog-layout__sidebar){flex:1 0 100%}
 * forces that box to full width. `.blog-layout` is `display:flex; flex-wrap:wrap`, so the
 * row wraps and the sidebar is pushed below the full height of the article — measured at
 * ~24,400px down on /blogs/dumbbells/dumbbell-exercises-for-seniors. Hits every
 * non-reviews article. Reviews articles are unaffected: in-content is blocklisted there.
 *
 * FIX
 * Watch `.blog-layout` and move each injected box into the article body at a top-level
 * paragraph boundary. The box stops being a flex item, the row un-wraps, and the ad ends
 * up in content rather than stranded below the fold.
 *
 * Idempotent: a moved box is tagged and never re-processed, so our own DOM writes do not
 * feed the observer back into a loop.
 */
(function () {
  'use strict';

  var MOVED = 'data-wh-relocated';
  var STRAY = '.blog-layout > .mv-ad-box:not([' + MOVED + '])';

  // Where the ad should end up: the article's rich-text body, best effort.
  function articleBody() {
    var main = document.querySelector('.blog-layout__main');
    if (!main) return null;
    return (
      main.querySelector('.element-text--rte') ||
      main.querySelector('.rte') ||
      main.querySelector('.article__body') ||
      main
    );
  }

  // Top-level blocks an ad can sit in front of without splitting a table or a figure.
  function anchors(host) {
    return Array.prototype.filter.call(host.children, function (el) {
      return /^(P|H2|H3|UL|OL)$/.test(el.tagName);
    });
  }

  function relocate() {
    var strays = document.querySelectorAll(STRAY);
    if (!strays.length) return;

    var host = articleBody();
    if (!host) return;

    var spots = anchors(host);

    Array.prototype.forEach.call(strays, function (box) {
      // Tag first: guarantees we never reprocess this node even if insertion throws.
      box.setAttribute(MOVED, '1');

      // Boxes already relocated into the body, so multiples spread out instead of stacking.
      var placed = host.querySelectorAll('[' + MOVED + ']').length;
      var idx = Math.floor(spots.length * (0.4 + 0.25 * placed));

      if (spots.length && idx < spots.length) {
        host.insertBefore(box, spots[idx]);
      } else {
        host.appendChild(box);
      }
    });
  }

  function start() {
    var layout = document.querySelector('.blog-layout');
    if (!layout) return;

    relocate(); // catch anything injected before we attached
    new MutationObserver(relocate).observe(layout, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
